<template>
  <div>
    <table class="summary-table">
      <tbody>
        <tr>
          <td class="label total">
            {{ $t('orders.details_summary.total_items') }}:
          </td>
          <td class="value">
            {{ getTotalCount }}
          </td>
        </tr>
        <tr>
          <td class="label">
            <v-icon>mdi-snowflake</v-icon>
            {{ $t('details_category.frozen') }}:
          </td>
          <td class="value">
            {{ getFrozenCount }}
          </td>
        </tr>
        <tr>
          <td class="label">
            <v-icon>mdi-scale-balance</v-icon>
            {{ $t('details_category.variable_weight') }}:
          </td>
          <td class="value">
            {{ getVariableWeightCount }}
          </td>
        </tr>
        <tr>
          <td class="label">
            {{ $t('details_category.other') }}:
          </td>
          <td class="value">
            {{ getOtherCount }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import _ from 'underscore'

export default {
  props: {
    orders: {
      type: Array,
      required: true
    }
  },

  computed: {
    getTotalCount () {
      return this.getDetailsCountByType(this.orders, 'total')
    },
    getFrozenCount () {
      return this.getDetailsCountByType(this.orders, 'frozen')
    },
    getVariableWeightCount () {
      return this.getDetailsCountByType(this.orders, 'variable_weight')
    },
    getOtherCount () {
      return this.getDetailsCountByType(this.orders, 'other')
    }
  },

  methods: {
    getDetailsCountByType (orders, type) {
      return _.reduce(this.orders, (prev, current) => {
        return prev + current.details_summary[type]
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.summary-table {
  width: 300px;
  float: right;
}

.label {
  text-align: right;

  &.total {
    font-weight: bold;
  }
}

.value {
  width: 40px;
  text-align: right;
  font-weight: bold;
}
</style>
